export default __webpack_public_path__ + "2018 molecular crystal.pdf";